import { Attribute, AttributeGroupType, AttributeProperty } from "react-builder"

export class Page extends Attribute {
    @AttributeProperty({ type: 'String' })
    title: string = ''
    @AttributeProperty({ type: 'String' })
    path: string = ''
    @AttributeProperty({ type: 'Boolean', title: 'Requires login?' })
    requiresLogin: boolean = false;
}